import { StepConnector as MuiStepConnector } from '@mui/material';
export const StepConnector = MuiStepConnector;
